
import React from 'react';
import { Textarea } from "@/components/ui/textarea";
import { useContentEditor } from './editor/useContentEditor';
import EditorToolbar from './editor/EditorToolbar';
import ContentPreview from './editor/ContentPreview';

interface ContentEditorProps {
  value: string;
  onChange: (value: string) => void;
}

const ContentEditor: React.FC<ContentEditorProps> = ({ value, onChange }) => {
  const {
    isUploading,
    isFormatting,
    fileInputRef,
    imageInputRef,
    handleTextChange,
    handleTextFormat, // We'll keep the function but won't expose the button
    handleAITextFormat,
    handleImageFileChange,
    handlePdfFileChange,
    handleImageUploadClick,
    handlePdfUploadClick
  } = useContentEditor(value, onChange);
  
  return (
    <div className="space-y-2">
      <EditorToolbar 
        onImageUploadClick={handleImageUploadClick}
        onPdfUploadClick={handlePdfUploadClick}
        onTextFormat={handleTextFormat} // We still pass this function even though the button is removed
        onAITextFormat={handleAITextFormat}
        isUploading={isUploading}
        isFormatting={isFormatting}
      />
      
      {/* Hidden file inputs */}
      <input
        type="file"
        ref={imageInputRef}
        onChange={handleImageFileChange}
        accept="image/*"
        style={{ display: 'none' }}
      />
      
      <input
        type="file"
        ref={fileInputRef}
        onChange={handlePdfFileChange}
        accept=".pdf,application/pdf"
        style={{ display: 'none' }}
      />
      
      <Textarea
        placeholder="Inhoud van de modal..."
        rows={10}
        value={value}
        onChange={handleTextChange}
        className="min-h-[200px] font-mono"
      />
      
      {isUploading && (
        <div className="text-sm text-muted-foreground">
          Bezig met uploaden...
        </div>
      )}
      
      {isFormatting && (
        <div className="text-sm text-muted-foreground">
          Bezig met AI tekstopmaak...
        </div>
      )}
      
      <ContentPreview content={value} />
    </div>
  );
};

export default ContentEditor;
